import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';

interface FormInputLayoutProps {
  label: string;
  required: boolean;
  description?: string;
  valueLength?: number;
  extraLabel?: string | React.ReactNode;
  limit?: number;
  className?: string;
}

const FormInputLayout: React.FC<FormInputLayoutProps> = ({
  label,
  required,
  description,
  valueLength,
  limit,
  extraLabel,
  children,
  className
}) => {
  const { requestInputLayoutContainer } = useStyles({
    tooLong: valueLength && limit ? valueLength > limit : false
  });

  return (
    <div className={clsx([requestInputLayoutContainer, className])}>
      <div className="label-box">
        <div className="label">
          <CustomizedTypography
            variant="h4"
            fontWeight="500"
            gutterBottoms={description ? 2 : 12}
          >
            {label} {required ? <b>*</b> : <small>(선택)</small>}
          </CustomizedTypography>
          {description && (
            <CustomizedTypography
              variant="body2"
              color="textSecondary"
              gutterBottoms={12}
            >
              {description}
            </CustomizedTypography>
          )}
        </div>
        {limit && (
          <CustomizedTypography className="length-counter">
            ({valueLength}/{limit})
          </CustomizedTypography>
        )}
        {extraLabel && typeof extraLabel === 'string' ? (
          <CustomizedTypography variant="body2" color="textSecondary">
            {extraLabel}
          </CustomizedTypography>
        ) : (
          extraLabel
        )}
      </div>
      {children}
    </div>
  );
};

export default FormInputLayout;

const useStyles = makeStyles((theme) => ({
  requestInputLayoutContainer: {
    '&:not(:last-child)': {
      marginBottom: 24
    },
    '& .label-box': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    '& .label': {
      '& b': {
        color: colorSet.errorBase
      },
      '& small': {
        color: colorSet.gray700,
        fontWeight: 400
      }
    },
    '& .length-counter': {
      color: ({ tooLong }: { tooLong: boolean }) =>
        !tooLong ? colorSet.gray900 : colorSet.errorMain
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: colorSet.gray900
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: colorSet.gray300
      }
    },
    '&.detailedRequest': {
      alignItems: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        '& .label-box': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }
      }
    }
  }
}));
